import axios from "axios";
import { store } from "../store/store";

export default async function LoginUser(user, password) {
  store.commit("incrementCarregando", true);
  try {
    const response = await axios({
      withCredentials: true,
      method: "post",
      data: {
        user: user,
        password: password,
      },
      url: `${process.env.VUE_APP_APIURL}/user/login`,
    });
    store.commit("incrementCarregando", false);
    return response;
  } catch (error) {
    store.commit("incrementCarregando", false);
    return error.response;
  }
}
